import React from 'react';

export class AuthController extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return <div>Auth</div>;
    }
}

export default AuthController;